/**
 * MAHI — the masthead row every screen opens with.
 *
 * The signature: a 36px affordance on the left (back button, avatar, or
 * nothing), the MAHI wordmark dead-centre, and a 36px affordance on the
 * right (a contextual action, or nothing). Both side slots hold their width
 * even when empty — that's what makes the centre slot's `justify-center`
 * actually centre in the *viewport*, not just in whatever space happens to
 * be left over, so a page with only a back button still gets a centred mark
 * rather than one that drifts toward the empty side.
 *
 * Page-specific chrome — a title, a search bar, filters, a collection
 * switcher — is not this component's job: render it as a second row
 * directly below, in the page itself. This row is only ever the masthead.
 *
 * MahiRouteLoader renders this exact row (with the wordmark slot replaced
 * by the animating letters) so the loading state and the real header share
 * the same pixel geometry — nothing to measure, nothing to hand off.
 */
import React from 'react';
import MahiWordmark from './MahiWordmark';

export default function MahiHeader({ left = null, right = null, onLogoClick, wordmark, className = '' }) {
  return (
    <div className={`shrink-0 px-4 pt-4 pb-2 flex items-center gap-2.5 z-30 ${className}`}>
      <div className="w-9 h-9 shrink-0 flex items-center justify-center">{left}</div>
      <div className="flex-1 flex justify-center min-w-0">
        {wordmark ?? <MahiWordmark onClick={onLogoClick} />}
      </div>
      <div className="w-9 h-9 shrink-0 flex items-center justify-center">{right}</div>
    </div>
  );
}
